import React from "react";

import { StyledColdStartControls } from "./ControlsStyle";

import Message from "./Message/Message";

export default function Controls({ setHelp }) {
  return (
    <StyledColdStartControls>
      <Message />
    </StyledColdStartControls>
  );
}
